import React, { FC } from 'react';
import { ToggleExtra } from '@common/components/Extras/controls';
import QuantityPicker from '@common/components/QuantityPicker';
import { ButtonWrapper, ToggleExtraButton } from './PerStay.styles';
import { Controller, useFormContext } from 'react-hook-form';
import { GuestOption } from '@common/components/Extras/Extra/layouts/shared/types';
import { PackagesFormValues } from '@features/DynamicPackagesConfigurationWizardNew/types';

export const PerStay: FC<{ index: number; maxQuantity: number | null }> = ({
  index,
  maxQuantity,
}) => {
  const { control } = useFormContext<PackagesFormValues>();
  return (
    <ButtonWrapper>
      {!!maxQuantity && (
        <Controller
          name={`extras.${index}.quantity`}
          control={control}
          render={({ field }) => (
            <QuantityPicker
              input={{
                value: field.value ?? 0,
                onChange: field.onChange,
              }}
              {...field}
              maxValue={maxQuantity}
            />
          )}
        />
      )}
      <ToggleExtraButton>
        <Controller
          name={`extras.${index}.isSelected`}
          control={control}
          render={({ field }) => (
            <ToggleExtra
              input={{
                value: field.value,
                onChange: (value: string | boolean | GuestOption[]) => {
                  field.onChange(value);
                },
              }}
              {...field}
            />
          )}
        />
      </ToggleExtraButton>
    </ButtonWrapper>
  );
};
